__turbopack_context__.v({
  "menuButton": "header-menu-button-module__BWaiyq__menuButton",
});
